import { render, staticRenderFns } from "./SolutionType.vue?vue&type=template&id=79d8f06b&scoped=true&"
import script from "./SolutionType.vue?vue&type=script&lang=js&"
export * from "./SolutionType.vue?vue&type=script&lang=js&"
import style0 from "./SolutionType.vue?vue&type=style&index=0&id=79d8f06b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d8f06b",
  null
  
)

export default component.exports